import ABCyaPhaser from "@abcya/abcya_phaser";
import { addAnimations, FeedMeFractionsAnimationData } from "../Animations";
import gameData from "../gameData";
import SoundAssetKeys from "../SoundAssetKeys";

export default class Monster extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        this.workingWidth = null;
        this.workingHeight = null;
        this.container = null;
        this.body = null;
        this.leftEye = null;
        this.rightEye = null;
        this.mouth = null;
        this.teeth = null;
        this.shadow = null;
        this.bodyContainer = null;
        this.blinkWaiter = null;
        this.chewCount = 0;

        this.container = this.scene.add.container();
        this.bodyContainer = this.scene.add.container();

        this.feet = this.scene.add.image(47, 165, ABCyaPhaser.Images.DEFAULT_ATLAS, "Feed-Me-Fractions-Animations/" + FeedMeFractionsAnimationData.animations.feet.frames[0].toString());

        this.body = this.scene.add.image(0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, "Feed-Me-Fractions-Animations/" + FeedMeFractionsAnimationData.animations.body.frames[0].toString());
        this.leftEye = this.scene.add.sprite(46, 44, ABCyaPhaser.Images.DEFAULT_ATLAS, "Feed-Me-Fractions-Animations/" + FeedMeFractionsAnimationData.animations.left_eye_idle.frames[0].toString());
        addAnimations(this.leftEye, "left_eye");
        this.rightEye = this.scene.add.sprite(109, 45, ABCyaPhaser.Images.DEFAULT_ATLAS, "Feed-Me-Fractions-Animations/" + FeedMeFractionsAnimationData.animations.right_eye_idle.frames[0].toString());
        addAnimations(this.rightEye, "right_eye");
        this.mouth = this.scene.add.sprite(30, 56, ABCyaPhaser.Images.DEFAULT_ATLAS, "Feed-Me-Fractions-Animations/" + FeedMeFractionsAnimationData.animations.mouth_idle.frames[0].toString());
        addAnimations(this.mouth, "mouth_eat");
        this.teeth = this.scene.add.image(92, 126, ABCyaPhaser.Images.DEFAULT_ATLAS, "Feed-Me-Fractions-Animations/" + FeedMeFractionsAnimationData.animations.teeth.frames[0].toString());

        this.shadow = this.scene.add.image(13, 200, ABCyaPhaser.Images.DEFAULT_ATLAS, "MonsterShadow");

        this.bodyContainer.add([this.body, this.leftEye, this.rightEye, this.teeth, this.mouth]);
        this.container.add([this.shadow, this.feet, this.bodyContainer]);
        this.add(this.container);

        this.workingWidth = this.body.width;
        this.workingHeight = this.feet.y + this.feet.height;

        this.blinkWaiter = Phaser.Math.Between(10, 54) / 10;

        let particleManager = this.scene.add.particles(ABCyaPhaser.Images.DEFAULT_ATLAS, "Crumb_1");
        this.add(particleManager);
        this.chewParticles = particleManager.createEmitter(
            {
                x: 0,
                y: 0,
                frame: ["Crumb_1", "Crumb_2", "Crumb_3"],
                lifespan: { min: 250, max: 500 },
                speedX: { min: -60, max: 60 },
                speedY: { min: -40, max: 40 },
                alpha: { start: 1, end: 0, ease: Phaser.Math.Easing.Expo.In },
                on: false
            }
        );
    }

    blink()
    {
        this.leftEye.play("left_eye");
        this.rightEye.play("right_eye");
    }

    initSmall()
    {
        // readjust the "pivot" of the container (the container pivot could be changed in Createjs but not in Phaser)
        let bounds = this.container.getBounds();
        this.container.iterate(child =>
        {
            child.x -= bounds.width / 2;
            child.y -= this.workingHeight;
        });
        this.curScale = 0.1;
        this.container.setScale(0.1);
    }

    growFull(time)
    {
        if (!time) time = 600;
        ABCyaPhaser.Tweens.addTween(this.container, time, { scale: 1 }, Phaser.Math.Easing.Linear);
    }

    eat()
    {
        this.teeth.alpha = 0;
        this.mouth.play("mouth_eat");
        this.mouth.once(Phaser.Animations.Events.ANIMATION_COMPLETE, this.doneEating, this);
        this.chewCount = 0;
        this.scene.time.delayedCall(100, this.chew, null, this);
    }

    chew()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._chew, this.scene);
        this.chewCount++;

        let getPosition = (go, x, y) =>
        {
            while (go.parentContainer != null && go.parentContainer != this)
            {
                x *= go.parentContainer.scaleX;
                y *= go.parentContainer.scaleY;
                x += go.parentContainer.x;
                y += go.parentContainer.y;
                go = go.parentContainer;
            }
            return { x: x, y: y };
        }
        let containerPos = getPosition(this.mouth, 110, 130);
        this.chewParticles.explode(20,containerPos.x, containerPos.y);

        if (this.chewCount <= 2)
        {
            this.scene.time.delayedCall(490, this.chew, null, this);
        }
    }

    doneEating()
    {
        this.teeth.alpha = 1;
        if (this.delegate)
        {
            this.curScale += (0.9 / 8);
            ABCyaPhaser.Tweens.addTween(this.container, 400, { delay: 120, scale: this.curScale }, Phaser.Math.Easing.Quadratic.Out);
            this.delegate.monsterFinishedEating();
        }
    }

    frown()
    {
        this.teeth.alpha = 0;
        this.mouth.scaleY = -1;
        this.mouth.y = 185;
    }

    tick(dt)
    {
        this.blinkWaiter -= dt;
        if (this.blinkWaiter <= 0)
        {
            this.blink();
            this.blinkWaiter = Phaser.Math.Between(10, 54) / 10;
        }
    }
}